import { render, staticRenderFns } from "./PolicyDetail.vue?vue&type=template&id=2abdf956"
import script from "./PolicyDetail.vue?vue&type=script&lang=js"
export * from "./PolicyDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports